<div
  [ngClass]="{
    size_10: this.space === 'size_10px',
    size_30: this.space === 'size_30px',
    size_50: this.space === 'size_50px',
    size_100: this.space === 'size_100px'
  }"
></div>
